export default {
  'pages.intention.title': 'Intent list',
  'pages.intention.search.id': 'Intent No.',
  'pages.intention.search.id.placeholder': 'Please enter the Intent No.',
  'pages.intention.search.name': 'Spu name',
  'pages.intention.search.name.placeholder':
    'Please enter the spu name or spu no.',
  'pages.intention.search.date': 'Order time',
  'pages.intention.search.date.placeholder1': 'Please select start time',
  'pages.intention.search.date.placeholder2': 'Please select end time',
  'pages.intention.header.info': 'Spu information',
  'pages.intention.header.craft': 'Craft',
  'pages.intention.header.color': 'Color',
  'pages.intention.header.quantity': 'Quantity',
  'pages.intention.list.id': 'Intent No.',
  'pages.intention.list.date': 'Order time',
  'pages.intention.list.person': 'Order person',
  'pages.intention.search.status': 'Intent Status',
  'pages.intention.search.status.placeholder':
    'Please Select the Intent Status',
  'pages.intention.header.action': 'Action',
};
